module.exports = require("xml");


//////////////////
// WEBPACK FOOTER
// external "xml"
// module id = 616
// module chunks = 0